import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const useOnFavoriteGameToggle = (eventTarget: EventTarget): void => {
    const triggerFavoriteGameToggleEvent = useCallback(({ gameFeed, gameCode, isFavorite, container }: {
        container?: string;
        gameFeed?: string;
        gameCode: string;
        isFavorite: boolean;
    }) => {
        const event = new CustomEvent('GAME_FAVORITES_HANDLER', { detail: [{
            container,
            gameFeed,
            gameCode,
            method: isFavorite ? 'Add' : 'Remove'
        }] });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('favorite-game-toggle', triggerFavoriteGameToggleEvent);

        return () => {
            publicEventsAPIService.off('favorite-game-toggle', triggerFavoriteGameToggleEvent);
        };
    }, [triggerFavoriteGameToggleEvent]);
};
